import React from 'react';

import {Icons, Sizes} from '@pb/kit-component-icon';
import IconButton from '@pb/kit-component-icon-button';

import {ipRangeRemoveButton, ipRangeRemoveButtonDisabled} from './remove-button.module.styl';

type Props = {
    disabled?: boolean,
    onRemove: () => void,
};
export const RemoveButton = ({disabled, onRemove}: Props) => (
    <IconButton
        disabled={disabled}
        className={`${ipRangeRemoveButton} ${disabled ? ipRangeRemoveButtonDisabled : ''}`}
        iconProps={{size: Sizes.Size_19, type: Icons.CLOSE}}
        onClick={onRemove}
    />
);
